import { defineStore } from 'pinia'

export const useFeatureToggleStore = defineStore('feature-toggle', () => {
  const featuresEnabledConfigMap = ref({
    /** 偏好設定 */
    favorite: {
      enabled: false,
    },
    /** 偏好設定 */
    preferences: {
      enabled: false,
    },
    /** 更多相似類別 */
    relatedTags: {
      enabled: false,
    },
    /** no-show 允許上傳 pdf 檔案 */
    noShowPdf: {
      enabled: true,
    },
  })

  const isFavoriteEnabled = computed(() => featuresEnabledConfigMap.value.favorite.enabled)
  const isPreferencesEnabled = computed(() => featuresEnabledConfigMap.value.preferences.enabled)
  const isRelatedTagsEnabled = computed(() => featuresEnabledConfigMap.value.relatedTags.enabled)
  const isNoShowPdfEnabled = computed(() => featuresEnabledConfigMap.value.noShowPdf.enabled)

  return {
    featuresEnabledConfigMap,
    isFavoriteEnabled,
    isPreferencesEnabled,
    isRelatedTagsEnabled,
    isNoShowPdfEnabled,
  }
})
